import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../components/Dashboard/Dashboard.vue';
import Visit from '../components/Visit/Visit.vue';
import CustomerHistory from '../components/CustomerHistory/CustomerHistory.vue';
import Skeleton from '../components/Skeleton/Skeleton.vue';
import InvalidToken from '../components/InvalidToken/InvalidToken.vue';

import VisitService from '../services/visit.service';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import AccessService from '../services/access.service';
import BusinessService from '../services/business.service';
import LangService from '../services/lang.service';

import store from '../store';

import { SET_PROGRESS, SET_ACCESS_LEVEL } from '../store/action-modulation.type';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/visit/:visitId',
      name: 'Skeleton',
      component: Skeleton,
      beforeEnter: (to, from, next) => {
        store.dispatch(SET_PROGRESS, true);

        VisitService.createVisit(to.params.visitId)
          .then(() => {
            next();
          })
          .catch((error) => {
            if (error.response.data === 'Missing X-ACCESS-TOKEN header' || error.response.status === 403) {
              next({ path: '/invalid-token' });
            } else if (error.response.status === 400) {
              next();
            }
          })
          .finally(() => {
            store.dispatch(SET_PROGRESS, false);
          });
      },
    },
    {
      path: '/visit/:visitId/surveys',
      name: 'Visit',
      component: Visit,
    },
    {
      path: '/business/:businessId/customer/:customerId/history',
      name: 'CustomerHistory',
      component: CustomerHistory,
    },
    {
      path: '/invalid-token',
      name: 'InvalidToken',
      component: InvalidToken,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.query.business_id) {
    BusinessService.setBusinessId(to.query.business_id);
  }
  if (to.query.lang) {
    LangService.setLang(to.query.lang);
  } else if (!LangService.getLang()) {
    LangService.setDefaultLang();
  }
  if (to.query.x_access_token) {
    AuthService.setToken(to.query.x_access_token);
  }
  ApiService.setHeader();

  if (BusinessService.getBusinessId()) {
    AccessService.getAccessLevel(BusinessService.getBusinessId()).then((data) => {
      store.commit(SET_ACCESS_LEVEL, data.data.accessLevel);
    })
    .finally(() => {
      next();
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js